import { type FileType, fileTypeToMimeMap, getFileExtensionByMimeType } from 'BreetHelpers';
import { useEffect, useState } from 'react';

interface IUseFileInfo {
	name: string;
	type: string;
	isLoaded: boolean;
	error: string;
	mimeType: FileType | undefined;
}

export const useFileInfo = (file: File | string | undefined): IUseFileInfo => {
	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const [error, setError] = useState<string>('');

	const isNotUrl = typeof file !== 'string';

	useEffect(() => {
		if (isNotUrl) return;

		setIsLoaded(false);
		setError('');

		const img = new Image();
		img.onload = () => setIsLoaded(true);
		img.onerror = () => setError('Failed to load');
		img.src = file;
	}, [file, isNotUrl]);

	const getFileName = () => {
		if (isNotUrl) return file?.name ?? '';
		const parts = file.split('/');
		return parts[parts.length - 1] || '';
	};

	const getFileType = () => {
		if (isNotUrl) return file?.type ?? '';
		const extension = file.split('.').pop()?.toLowerCase();
		return extension ? fileTypeToMimeMap[extension as FileType] : '';
	};

	const type = getFileType();

	const mimeType = getFileExtensionByMimeType(type);

	return {
		name: getFileName(),
		type,
		isLoaded,
		error,
		mimeType,
	};
};
